import { render, staticRenderFns } from "./ExportImport.vue?vue&type=template&id=50fc945e&scoped=true&"
import script from "./ExportImport.vue?vue&type=script&lang=ts&"
export * from "./ExportImport.vue?vue&type=script&lang=ts&"
import style0 from "./ExportImport.vue?vue&type=style&index=0&id=50fc945e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc945e",
  null
  
)

export default component.exports